var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0.0208333 1.4375 0.21875 0.96875 0.59375 0.59375C0.96875 0.21875 1.4375 0.0208333 2 0H10C10.5625 0.0208333 11.0312 0.21875 11.4062 0.59375C11.7812 0.96875 11.9792 1.4375 12 2V10C11.9792 10.5625 11.7812 11.0312 11.4062 11.4062C11.0312 11.7812 10.5625 11.9792 10 12H2C1.4375 11.9792 0.96875 11.7812 0.59375 11.4062C0.21875 11.0312 0.0208333 10.5625 0 10V2ZM17.4688 1.125C17.8021 1.3125 17.9792 1.60417 18 2V10C17.9792 10.3958 17.8021 10.6875 17.4688 10.875C17.1146 11.0625 16.7708 11.0521 16.4375 10.8438L13.4375 8.84375L13 8.53125V8V4V3.46875L13.4375 3.15625L16.4375 1.15625C16.7708 0.96875 17.1146 0.958333 17.4688 1.125Z",
    fill: "#45474C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.a703555a43b7ec508dd643e6bc1a63a7.svg";
export { ForwardRef as ReactComponent };